import {withRTLFlip} from './index';
import {Image} from 'react-native';
const RTLImage = withRTLFlip(Image);
export default RTLImage;
